function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/** localStorage key for persisted wishlist pincode on /rewardStore */
export var WISHLIST_PINCODE_KEY = "wishlistPincode";

/** Extracts Amazon ASIN from product or short links. */
export function extractAmazonAsin(url) {
  if (!url) return null;
  var patterns = [/\/dp\/([A-Z0-9]{10})/i, /\/gp\/product\/([A-Z0-9]{10})/i, /\/product\/([A-Z0-9]{10})/i, /[?&]asin=([A-Z0-9]{10})/i];
  for (var _i = 0, _patterns = patterns; _i < _patterns.length; _i++) {
    var pattern = _patterns[_i];
    var match = url.match(pattern);
    if (match) return match[1].toUpperCase();
  }
  return null;
}
export function findCartItemByAsin(cartData, asin) {
  var _cartData$cartValues;
  if (!asin || !(cartData !== null && cartData !== void 0 && (_cartData$cartValues = cartData.cartValues) !== null && _cartData$cartValues !== void 0 && _cartData$cartValues.length)) return null;
  return cartData.cartValues.find(function (item) {
    return item.productSku === asin;
  }) || null;
}
function getCartStorageKey(isPoints) {
  return isPoints ? "cartData_reloyrewardpoints" : "cartData";
}
export function getCartData() {
  var isPoints = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var oldCartData = localStorage.getItem(getCartStorageKey(isPoints));
  if (!oldCartData) {
    return {
      cartValues: [],
      totalMrp: 0,
      totalPoints: 0,
      totalShippingFee: 0,
      totalConvenienceFee: 0,
      totalProduct: 0
    };
  }
  return JSON.parse(oldCartData);
}

/** Adds a deal to cartData (same shape as DealsLayout OnCartClick) and opens the cart modal. */
export function addDealToCart(deal) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    dispatch = _ref.dispatch,
    dealAction = _ref.dealAction;
  var isPoints = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var cartData = getCartData(isPoints);
  if (cartData.cartValues.some(function (item) {
    return item.id === deal.id;
  })) {
    return {
      added: false,
      cartData: cartData,
      reason: "already_in_cart"
    };
  }
  cartData.cartValues.push({
    id: deal.id,
    title: deal.title,
    endDate: deal.endDate,
    displayImageUrl: deal.displayImageUrl,
    vendorLogoUrl: deal.vendorLogoUrl,
    productMrp: deal.productMrp,
    thumbnailImageUrl: deal.thumbnailImageUrl,
    points: deal.points,
    productShippingFee: deal.productShippingFee || 0,
    productConvenienceFee: deal.productConvenienceFee || 0,
    tags: deal.tags || [],
    productSku: deal.productSku || null
  });
  cartData.totalMrp += deal.productMrp || 0;
  cartData.totalPoints += deal.points || 0;
  cartData.totalShippingFee += deal.productShippingFee || 0;
  cartData.totalConvenienceFee += deal.productConvenienceFee || 0;
  cartData.totalProduct += 1;
  localStorage.setItem(getCartStorageKey(isPoints), JSON.stringify(cartData));
  if (dispatch && dealAction !== null && dealAction !== void 0 && dealAction.setCartModalVisible) {
    dispatch(dealAction.setCartModalVisible(true));
  }
  window.dispatchEvent(new Event("cartUpdated"));
  return {
    added: true,
    cartData: cartData
  };
}

/** Updates price/stock for an existing cart line (duplicate Amazon re-add). */
export function updateDealInCart(deal) {
  var _deal$title, _deal$endDate, _deal$displayImageUrl, _deal$vendorLogoUrl, _deal$thumbnailImageU, _deal$productMrp, _deal$points, _ref3, _deal$productShipping, _ref4, _deal$productConvenie, _ref5, _deal$productSku;
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    dispatch = _ref2.dispatch,
    dealAction = _ref2.dealAction;
  var isPoints = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var cartData = getCartData(isPoints);
  var index = cartData.cartValues.findIndex(function (item) {
    return item.id === deal.id;
  });
  if (index === -1) {
    return {
      updated: false,
      cartData: cartData,
      reason: "not_in_cart"
    };
  }
  var previous = cartData.cartValues[index];
  cartData.totalMrp -= previous.productMrp || 0;
  cartData.totalPoints -= previous.points || 0;
  cartData.totalShippingFee -= previous.productShippingFee || 0;
  cartData.totalConvenienceFee -= previous.productConvenienceFee || 0;
  cartData.cartValues[index] = _objectSpread(_objectSpread({}, previous), {}, {
    title: (_deal$title = deal.title) !== null && _deal$title !== void 0 ? _deal$title : previous.title,
    endDate: (_deal$endDate = deal.endDate) !== null && _deal$endDate !== void 0 ? _deal$endDate : previous.endDate,
    displayImageUrl: (_deal$displayImageUrl = deal.displayImageUrl) !== null && _deal$displayImageUrl !== void 0 ? _deal$displayImageUrl : previous.displayImageUrl,
    vendorLogoUrl: (_deal$vendorLogoUrl = deal.vendorLogoUrl) !== null && _deal$vendorLogoUrl !== void 0 ? _deal$vendorLogoUrl : previous.vendorLogoUrl,
    thumbnailImageUrl: (_deal$thumbnailImageU = deal.thumbnailImageUrl) !== null && _deal$thumbnailImageU !== void 0 ? _deal$thumbnailImageU : previous.thumbnailImageUrl,
    productMrp: (_deal$productMrp = deal.productMrp) !== null && _deal$productMrp !== void 0 ? _deal$productMrp : previous.productMrp,
    points: (_deal$points = deal.points) !== null && _deal$points !== void 0 ? _deal$points : previous.points,
    productShippingFee: (_ref3 = (_deal$productShipping = deal.productShippingFee) !== null && _deal$productShipping !== void 0 ? _deal$productShipping : previous.productShippingFee) !== null && _ref3 !== void 0 ? _ref3 : 0,
    productConvenienceFee: (_ref4 = (_deal$productConvenie = deal.productConvenienceFee) !== null && _deal$productConvenie !== void 0 ? _deal$productConvenie : previous.productConvenienceFee) !== null && _ref4 !== void 0 ? _ref4 : 0,
    productSku: (_ref5 = (_deal$productSku = deal.productSku) !== null && _deal$productSku !== void 0 ? _deal$productSku : previous.productSku) !== null && _ref5 !== void 0 ? _ref5 : null
  });
  cartData.totalMrp += cartData.cartValues[index].productMrp || 0;
  cartData.totalPoints += cartData.cartValues[index].points || 0;
  cartData.totalShippingFee += cartData.cartValues[index].productShippingFee || 0;
  cartData.totalConvenienceFee += cartData.cartValues[index].productConvenienceFee || 0;
  localStorage.setItem(getCartStorageKey(isPoints), JSON.stringify(cartData));
  if (dispatch && dealAction !== null && dealAction !== void 0 && dealAction.setCartModalVisible) {
    dispatch(dealAction.setCartModalVisible(true));
  }
  window.dispatchEvent(new Event("cartUpdated"));
  return {
    updated: true,
    cartData: cartData
  };
}